<template>
  <b-card
    no-body
    class="download-card text-white"
  >
    <b-card-body>
      <div
        class="d-flex flex-column flex-md-row align-items-md-center"
      >
        <div class="mb-2 mb-md-0 mr-md-2">
          {{ $t('Practical tools') }}:
        </div>

        <div class="d-flex flex-column flex-md-row gap-1">
          <a
            v-for="link in links"
            :key="link.title"
            :href="link[`href-${$i18n.locale}`]"
            download
            class="download-link mb-md-0 mb-1"
          >
            <feather-icon
              size="18"
              icon="DownloadIcon"
              style="margin-right: 2px"
            />
            <span>
              {{ $t(link.title) }}
            </span>
          </a>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
  },
  props: {
    role: {
      type: String,
      required: true,
      validator: value => ['mentee', 'mentor'].includes(value),
    },
  },
  computed: {
    links() {
      return this.role === 'mentee'
        ? [
          {
            title: 'Mentees’ Guide',
            'href-en': '/PUBLICLY SHARED_Mentees\' training ENG 5_25.pdf',
            'href-gr': '/PUBLICLY_SHARED_Mentees_ training 4_2025.pdf',
          },
          {
            title: 'Action plan (Three-month relationship)',
            'href-en': '/PUBLICLY SHARED_Action plan_three-month relationship_ENG.docx',
            'href-gr': '/PUBLICLY SHARED_Σχέδιο δράσης_τρίμηνη συνεργασία.docx',
          },
          {
            title: 'Action plan (Six-month relationship)',
            'href-en': '/PUBLICLY SHARED_Action plan_six-month relationship_ENG.docx',
            'href-gr': '/PUBLICLY SHARED_Σχέδιο δράσης_εξάμηνη συνεργασία.docx',
          },
          {
            title: 'Mentoring contract',
            'href-en': '/PUBLICLY SHARED_Mentoring contract_ENG.docx',
            'href-gr': '/PUBLICLY SHARED_Συμβόλαιο_mentoring.docx',
          },
        ]
        : [
          {
            title: 'Mentors’ Guide',
            'href-en': '/PUBLICLY_SHARED_Mentors\' training ENG_ 5_25.pdf',
            'href-gr': '/PUBLICLY_SHARED_Mentors\' training 4_25.pdf',
          },
          {
            title: 'Action plan (Three-month relationship)',
            'href-en': '/PUBLICLY SHARED_Action plan_three-month relationship_ENG.docx',
            'href-gr': '/PUBLICLY SHARED_Σχέδιο δράσης_τρίμηνη συνεργασία.docx',
          },
          {
            title: 'Action plan (Six-month relationship)',
            'href-en': '/PUBLICLY SHARED_Action plan_six-month relationship_ENG.docx',
            'href-gr': '/PUBLICLY SHARED_Σχέδιο δράσης_εξάμηνη συνεργασία.docx',
          },
          {
            title: 'Mentoring contract',
            'href-en': '/PUBLICLY SHARED_Mentoring contract_ENG.docx',
            'href-gr': '/PUBLICLY SHARED_Συμβόλαιο_mentoring.docx',
          },
        ]
    },
  },
}
</script>

<style lang="scss" scoped>
.download-card {
  background-color: #804470;
  border-radius: 12px;
  font-weight: bold;
}

.download-link {
  color: #ffffff;
  text-decoration: underline;
  margin-right: 20px;
}

.download-link:hover {
  opacity: 0.8;
}
</style>
